<template>
	<div>
		<offer-edit-specific-quality-parameter
			v-for="parameter in productQualityParameters"
			:key="'EDIT_PARAMETER_' + parameter.id"
			:form="form"
			:parameter="parameter"
		>
		</offer-edit-specific-quality-parameter>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			form: this.value,
		};
	},
	computed: {
		productQualityParameters() {
			return this.$cropOptions.getProductQualityParameters(
				this.form.product.type,
				this.form.product.grade
			);
		},
	},
};
</script>
